import axios from "axios";
import { setIVR } from "@/helpers/BatchService.js";

import {
  authDeviceWithDomainHeader,
  authWithDomainHeader,
} from "../authServices/auth.header";

const API_URL = process.env.VUE_APP_ROOT_API;
class IVRService {
  // Get Voice Mail List
  async getIVRList() {
    return await axios
      .get(API_URL + `call-app/ivr-menu`, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  async getIVRListByColumn(filter, domain_uuid = null) {
    return await axios
      .get(API_URL + `call-app/ivr-menu` + filter, {
        headers: domain_uuid
          ? authWithDomainHeader(domain_uuid)
          : authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Add IVR
  async AddIVRItem(data) {
    return await axios
      .post(API_URL + `call-app/ivr-menu`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setIVR();
        return response.data;
      });
  }

  // Get IVR Item
  async getIVRItem(ivr_uuid) {
    return await axios
      .get(API_URL + `call-app/ivr-menu/${ivr_uuid}`, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Edit IVR Item
  async updateIVRItem(ivr_uuid, data) {
    return await axios
      .put(API_URL + `call-app/ivr-menu/${ivr_uuid}`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setIVR();
        return response.data;
      });
  }

  // Edit IVR Item
  async updateIVRItemStatus(ivr_uuid, data) {
    return await axios
      .patch(API_URL + `call-app/ivr-menu/${ivr_uuid}`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  //delete IVR Item
  async deleteIVRItem(ivr_uuid) {
    return await axios
      .delete(API_URL + `call-app/ivr-menu/${ivr_uuid}`, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setIVR();
        return response.data;
      });
  }
}

export default new IVRService();
